import * as React from "react";
const SvgSpeed4X20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M1.838 13.145h5.145V15.5h1.755v-2.355h1.785V11.54H8.738V4.865H6.353L1.838 11.15v1.995Zm5.145-1.605H3.458l3.525-4.905v4.905ZM12.8 6.665 11.75 7.7l2.49 2.565-2.506 2.565 1.035 1.05 2.505-2.565 2.52 2.565 1.02-1.05-2.505-2.565 2.505-2.58-1.05-1.02-2.49 2.55-2.475-2.55Z"
    })
  );
export default SvgSpeed4X20Px;
